/* ── page furniture ─────────────────────────────────────────── */

export function PageHead({ crumb, title, sub, actions }) {
  return (
    <>
      {crumb && <div className="crumb">{crumb}</div>}
      <div className="page-head">
        <div>
          <h1>{title}</h1>
          {sub && <div className="sub">{sub}</div>}
        </div>
        {actions && <div style={{ display: 'flex', gap: 9, flexWrap: 'wrap' }}>{actions}</div>}
      </div>
    </>
  );
}

export function Card({ children, className = '', style }) {
  return <div className={`card ${className}`.trim()} style={style}>{children}</div>;
}

export function CardH({ title, action }) {
  return (
    <div className="card-h">
      <b>{title}</b>
      {action}
    </div>
  );
}

export function Link({ children, onClick }) {
  return <span className="link" onClick={onClick} style={{ cursor: 'pointer' }}>{children}</span>;
}

export function Btn({ variant, children, onClick, style, title, disabled }) {
  const cls = variant ? `btn ${variant}` : 'btn';
  return (
    <button className={cls} onClick={onClick} style={style} title={title} disabled={disabled}>
      {children}
    </button>
  );
}

/**
 * A tone-coloured label. `onClick` makes it a target — the chip itself, not a
 * span nested inside it, so the whole coloured area is the hit area.
 */
export function Chip({ tone = 'grey', children, style, title, onClick }) {
  return (
    <span
      className={`chip c-${tone}`}
      style={onClick ? { cursor: 'pointer', ...style } : style}
      title={title}
      onClick={onClick}
    >
      {children}
    </span>
  );
}

export function Tabs({ tabs, active, onChange }) {
  return (
    <div className="tabs">
      {tabs.map((t) => (
        <button key={t.id} className={active === t.id ? 'on' : ''} onClick={() => onChange(t.id)}>
          {t.label}
        </button>
      ))}
    </div>
  );
}

/**
 * A row of filter chips. It carries its own bottom margin but no top one,
 * because it almost always follows a page head that has already spaced it —
 * `className` is for the times it does not.
 */
export function Filters({ children, className = '' }) {
  return <div className={`filters ${className}`.trim()} style={{ marginBottom: 14 }}>{children}</div>;
}

/** `disabled` keeps a choice visible but unselectable — it is not offered yet. */
export function FChip({ on, children, onClick, disabled, title }) {
  return (
    <div
      className={`fchip${on && !disabled ? ' on' : ''}${disabled ? ' dim' : ''}`}
      onClick={disabled ? undefined : onClick}
      title={title}
      aria-disabled={disabled || undefined}
    >
      {children}
    </div>
  );
}
